<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="dg.count.value" class="v3-count">{{ dg.count.value }}</span>
      <span class="spacer"></span>
      <span v-if="dg.staleCount.value" class="v3-dlg-stalecount">{{ dg.staleCount.value }} stalled</span>
    </div>

    <V3Skeleton v-if="dg.isLoading.value && !dg.count.value" shape="list" :heading="false" />
    <div v-else-if="!dg.count.value" class="v3-task-empty" v-testid="testid + '-empty'">Nothing delegated — invitations you send will appear here.</div>

    <template v-else>
      <button v-if="dg.showAll.value" class="v3-viewall" type="button" v-testid="testid + '-show-less'" @click="dg.showAll.value = false">
        Show less
      </button>

      <div class="v3-dlist">
      <div
        v-for="r in dg.shownRows.value"
        :key="r.document_task_id || r.reference"
        class="v3-drow"
        :class="{ 'is-stale': dg.isStale(r) }"
        role="button"
        tabindex="0"
        v-testid="testid + '-row-' + (r.document_task_id || r.reference)"
        @click="open(r)"
      >
        <div class="v3-drow-head">
          <span class="v3-drow-title">{{ r.doc_title || r.doc_name || r.reference }}</span>
          <span class="v3-spill" :style="{ color: dg.statusColour(r) }"><span class="dot"></span>{{ dg.statusLabel(r) }}</span>
        </div>
        <div class="v3-drow-meta">
          <span v-for="(m, mi) in dg.metaParts(r)" :key="mi">{{ m }}</span>
        </div>
        <div class="v3-drow-foot">
          <span class="v3-drow-note" :class="{ 'is-stale': dg.isStale(r) }">
            <span v-if="dg.isStale(r)" class="ms">schedule</span>{{ dg.note(r) }}
          </span>
          <button v-if="dg.isStale(r)" class="v3-linkbtn" type="button" v-testid="testid + '-row-' + (r.document_task_id || r.reference) + '-remind'" @click.stop="open(r)">Remind</button>
        </div>
      </div>
      </div>

      <button v-if="dg.count.value > limit" class="v3-viewall" type="button" v-testid="testid + '-view-all'" @click="dg.showAll.value = !dg.showAll.value">
        {{ dg.showAll.value ? 'Show less' : 'View all (' + dg.count.value + ')' }}
      </button>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { delegated } from "@rm-ui/homepage/delegated";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) Delegated — thin Vue 2 presentation over the shared
// `delegated` composable (@rm-ui/homepage/delegated), backed by
// POST Report/delegated. Sibling: rm-portal-beta DelegatedWidget.vue.
export default {
  name: "cLandingV3Delegated",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const dg = delegated({
      http: axios,
      getLimit: () => props.definition.limit || 6,
    });
    return { dg };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Delegated";
    },
    title() {
      return this.definition.title || "My Delegations";
    },
    limit() {
      return this.definition.limit || 6;
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
